import { render, staticRenderFns } from "./SecondaryStructreEditor.vue?vue&type=template&id=de72c116&scoped=true&"
import script from "./SecondaryStructreEditor.vue?vue&type=script&lang=js&"
export * from "./SecondaryStructreEditor.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryStructreEditor.vue?vue&type=style&index=0&id=de72c116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de72c116",
  null
  
)

export default component.exports